import $ from 'jquery';
import contentTemplate from 'properties/style/button-font.ejs';
import themeService from 'ThemeService';
import BasePropertyView from 'BasePropertyView'
import { pickerCfg } from 'pickerCfg';
import fontService from '../../../service/FontService';

class StyleButtonFontView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';

        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change #buttonFontFamily, #buttonFontSize, #customButtonFontFamily': 'updateAttributes',
            'change input[type=color]': 'updateColorAttributes',
            'change #buttonTextColor': 'updateColorAttributesWithValidation',
            'click #buttonBoldText, #buttonItalicText': 'updateTextStyleAttributes'
        }; 

        let correctString = (s) => {
            return typeof(s) === "string" ?
                        s.split(' ').filter( i => i !== '').join(' ') : s;
        };
       
        let buttonTextWeight = correctString(this.model.get('buttonTextWeight')); 
        if (!buttonTextWeight || buttonTextWeight === 'normal !important') {
            this.model.set('buttonTextWeight', 'normal !important', { silent: true });
            this.model.set('buttonBoldSelection', this.unselectedColor, { silent: true });
        } else if (buttonTextWeight === 'bold !important') { 
            this.model.set('buttonBoldSelection', this.selectedColor, { silent: true });
        }

        let buttonTextStyle = correctString(this.model.get('buttonTextStyle'));   
        if (!buttonTextStyle || buttonTextStyle === 'normal !important') {                                                     
            this.model.set('buttonTextStyle', 'normal !important', { silent: true });
            this.model.set('buttonItalicSelection', this.unselectedColor, { silent: true });
        } else if (buttonTextStyle === 'italic !important') {
            this.model.set('buttonItalicSelection', this.selectedColor, { silent: true });
        }

        let currentFont = this.resolveThemeFontProperty('buttonFontFamily');
        fontService.initCustomFont(this.model, currentFont, true);

        return this;
    }

    updateAttributes(ev, columnModel = undefined, name = undefined, value = undefined) {
        let
            propName = ev.currentTarget.name || name,
            propVal = ev.currentTarget.name ? ev.currentTarget.value : value,
            oldValue = this.model.get(propName);

        const webFont = fontService.webFonts.find(font => font.name === propVal);

        if (webFont) {
            fontService.loadWebFontResource(webFont);
        }

        if(propName === "customButtonFontFamily" || propName === "buttonFontFamily"){
            propVal = fontService.updateCustomFont(this.model, propVal, true);
            this.model.set('buttonFontFamily', propVal);
        }
        
        super.updateAttributes(ev, columnModel, name, value);

        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }
    }

    updateTextStyleAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;

        var weight = this.model.get('buttonTextWeight');
        var style = this.model.get('buttonTextStyle');

        if (propName === 'buttonTextWeight') {
            if (this.model.get('buttonTextWeight') === 'bold !important') {
                this.model.set('buttonBoldSelection', this.unselectedColor, { silent: true });
                weight = 'normal !important';
            } else {
                this.model.set('buttonBoldSelection', this.selectedColor, { silent: true });
                weight = 'bold !important';
            }
        }

        if (propName === 'buttonTextStyle') {
            if (this.model.get('buttonTextStyle') === 'italic !important') {
                this.model.set('buttonItalicSelection', this.unselectedColor, { silent: true });
                style = 'normal !important';
            } else {
                this.model.set('buttonItalicSelection', this.selectedColor, { silent: true });
                style = 'italic !important';
            }
        }

        this.model.set('buttonTextWeight', weight, { silent: true });
        this.model.set('buttonTextStyle', style, { silent: true });
        this.model.trigger('change', this.model);
    }

    resolveAttributes(base, name) {
        let fontPropsArray = themeService.resolve(base).split(',');
        let result = 'normal !important';
        if (name === 'buttonTextWeight') {
            if (fontPropsArray[2]) {
                result = fontPropsArray[2].trim().toLowerCase();
            }
        } else {
            if (fontPropsArray[3]) {
                result = fontPropsArray[3].trim().toLowerCase();
            }
        }
        return result;
    }

    selectMask(value) {
        switch (value) {
            case 'bold !important': return this.selectedColor;
            case 'italic !important': return this.selectedColor;
            default: return this.unselectedColor;
        }
    }

    updateForm() {
        //set selected index to model value
        if (this.model.get('buttonFontSize')) {
            $('#buttonFontSize').find('option[value='
                + this.resolveThemeFontProperty('buttonFontSize')
                + ']').attr('selected', true);
        }

        if (this.model.get('buttonFontFamily')) {
            // Font property can have spaces in it. Quote it.

            let font = this.resolveThemeFontProperty('buttonFontFamily');
            const customFont = fontService.isCustomFont(font);
            font = !customFont ? font : "__custom__";
            $('#buttonFontFamily').find('option[value="' + font + '"]').attr('selected', true);

        }
    }

    render() {
        super.render();
        let props = this.resolveThemeColors(this.model, ['buttonTextColor']);
       
        if (this.isThemeProperty(props.buttonTextWeight)) {
            props.buttonTextWeight = this.resolveAttributes(props.buttonTextWeight, 'buttonTextWeight');
            props.buttonBoldSelection = this.selectMask(props.buttonTextWeight);
        }
        
        if (this.isThemeProperty(props.buttonTextStyle)) {
            props.buttonTextStyle = this.resolveAttributes(props.buttonTextStyle, 'buttonTextStyle');
            props.buttonItalicSelection = this.selectMask(props.buttonTextStyle);
        }

        props.buttonBoldSelection = props.buttonBoldSelection || 'transparent';
        props.buttonItalicSelection = props.buttonItalicSelection || 'transparent';

        this.$el.html(this.template(props));

        const fonts = fontService.loadFontsDropDown(true);
        $("#buttonFontFamily").append(fonts);


        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.updateForm();
        this.delegateEvents();

        return this;
    }

}

export default StyleButtonFontView;
